// import {NodeType} from "../shared/NodeType";
import { TokenType } from "./token-type";

export class Token {

    constructor(public value: string, public type: TokenType, public isTransient = false) {
    }

    public disableKeywordsAtEndOfQuery(): void {

        switch (this.type) {
            case TokenType.And:
            // case TokenType.From:
            case TokenType.Not:
            case TokenType.Or:
            case TokenType.PotentialDateOperator:
            // case TokenType.PotentialKeyWord:
            // case TokenType.To:
            case TokenType.WOperator:
            case TokenType.Within:
            case TokenType.PotentialOf:
                this.type = TokenType.Word;
                break;
            default:
                return;
        }

    }

    public disableKeywordsAtStartOfQuery(): void {

        switch (this.type) {
            case TokenType.Near:
            case TokenType.And:
            case TokenType.Or:
            case TokenType.WOperator:
            case TokenType.Within:
            case TokenType.PotentialOf:
                this.type = TokenType.Word;
                break;
            default:
                return;
        }

    }

    public isValidInYearField(): boolean {
        switch (this.type) {
            // case TokenType.Number:
            // case TokenType.DefiniteDate:
            // case TokenType.PotentialDateOperator:
            // case TokenType.From:
            // case TokenType.To:
            // case TokenType.OpenSquareBracket:
            // case TokenType.CloseSquareBracket:
            // case TokenType.OpenBracket:
            // case TokenType.CloseBracket:
            case TokenType.Within:
            case TokenType.Wildcard:
            case TokenType.DefiniteOf:
            case TokenType.PotentialOf:
            case TokenType.Near:
            case TokenType.Phrase:
            case TokenType.WOperator:
            // case TokenType.PotentialKeyWord:
            case TokenType.Word:
                return false;
            default:
                return true;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/helpers/search-tree/token.ts